module.exports = __webpack_public_path__ + "static/media/bong.817a9733.svg";